"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractiveStreamListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _virtualStreamEvent = require("../../../utils/virtualStreamEvent");
var _InteractiveStreamListItem = require("./InteractiveStreamListItem.styled");
var InteractiveStreamListItem = exports.InteractiveStreamListItem = function InteractiveStreamListItem(_ref) {
  var featuredImage = _ref.featuredImage,
    title = _ref.title,
    description = _ref.description,
    startOn = _ref.startOn,
    endOn = _ref.endOn,
    shortId = _ref.shortId;
  var location = window.location;
  var baseUrl = "".concat(location.protocol, "//").concat(location.host);
  var url = "".concat(baseUrl, "/streams/").concat(shortId);
  return _react["default"].createElement(_InteractiveStreamListItem.StyledWrapper, null, _react["default"].createElement(_InteractiveStreamListItem.StyledImgContainer, null, featuredImage ? _react["default"].createElement("img", {
    src: featuredImage,
    alt: "featured image for ".concat(title)
  }) : _react["default"].createElement(_InteractiveStreamListItem.DefaultImage, null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faImage
  }))), _react["default"].createElement(_InteractiveStreamListItem.StyledDetail, null, _react["default"].createElement(_InteractiveStreamListItem.StyledHeader, null, title), _react["default"].createElement(_InteractiveStreamListItem.StreamInfo, null, _react["default"].createElement(_InteractiveStreamListItem.StyledInfo, null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: "#8D91AF",
    icon: _freeSolidSvgIcons.faCalendar
  }), _react["default"].createElement(_InteractiveStreamListItem.StyledSpan, null, (0, _virtualStreamEvent.getEventStartDate)(startOn))), _react["default"].createElement(_InteractiveStreamListItem.StyledInfo, null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: "#8D91AF",
    icon: _freeSolidSvgIcons.faClock
  }), _react["default"].createElement(_InteractiveStreamListItem.StyledSpan, null, (0, _virtualStreamEvent.getEventStartTime)(startOn, endOn)))), _react["default"].createElement(_InteractiveStreamListItem.StyledArticle, null, description)), _react["default"].createElement(_InteractiveStreamListItem.StyledLinkContainer, null, _react["default"].createElement(_InteractiveStreamListItem.StyledLink, {
    href: url
  }, "Join now")));
};
InteractiveStreamListItem.propTypes = {
  featuredImage: _propTypes["default"].string,
  title: _propTypes["default"].string,
  endOn: _propTypes["default"].number,
  startOn: _propTypes["default"].number,
  description: _propTypes["default"].string,
  shortId: _propTypes["default"].string
};